<template>
	<svg
		width="14"
		height="10"
		viewBox="0 0 14 10"
		fill="none"
		:class="iconColor"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M3.84999 5.75C3.43578 5.75 3.09999 5.41421 3.09999 5C3.09999 4.58579 3.43578 4.25 3.84999 4.25H12.85C13.2642 4.25 13.6 4.58579 13.6 5C13.6 5.41421 13.2642 5.75 12.85 5.75H3.84999ZM3.84999 9.35C3.43578 9.35 3.09999 9.01421 3.09999 8.6C3.09999 8.18579 3.43578 7.85 3.84999 7.85H12.85C13.2642 7.85 13.6 8.18579 13.6 8.6C13.6 9.01421 13.2642 9.35 12.85 9.35H3.84999ZM3.84999 2.15C3.43578 2.15 3.09999 1.81421 3.09999 1.4C3.09999 0.985786 3.43578 0.65 3.84999 0.65H12.85C13.2642 0.65 13.6 0.985786 13.6 1.4C13.6 1.81421 13.2642 2.15 12.85 2.15H3.84999ZM0.399994 5C0.399994 4.50396 0.802938 4.1 1.29999 4.1C1.79604 4.1 2.19999 4.50294 2.19999 5C2.19999 5.49605 1.79705 5.9 1.29999 5.9C0.803949 5.9 0.399994 5.49706 0.399994 5ZM0.399994 8.6C0.399994 8.10396 0.802938 7.7 1.29999 7.7C1.79604 7.7 2.19999 8.10294 2.19999 8.6C2.19999 9.09605 1.79705 9.5 1.29999 9.5C0.803949 9.5 0.399994 9.09706 0.399994 8.6ZM0.399994 1.4C0.399994 0.903955 0.802938 0.5 1.29999 0.5C1.79604 0.5 2.19999 0.902944 2.19999 1.4C2.19999 1.89604 1.79705 2.3 1.29999 2.3C0.803949 2.3 0.399994 1.89706 0.399994 1.4Z" 
			fill="currentColor"
		/>
	</svg>
</template>
<script setup>
const props = defineProps({
	iconColor:{
		type:String,
		default:'#444C58'
	}
}
);
</script>
